import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Home, 
  MessageSquare, 
  LayoutDashboard, 
  Network, 
  Layers, 
  Radio, 
  Box,
  Sparkles,
  Wand2,
  Activity
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navigation = [
  { name: 'Dashboard', href: '/', icon: Home },
  { name: 'Live Tasks', href: '/live-tasks', icon: Activity },
  { name: 'Setup Wizard', href: '/onboarding-wizard', icon: Wand2 },
  { name: 'Onboarding', href: '/onboarding', icon: Sparkles },
  { name: 'Sessions', href: '/sessions', icon: LayoutDashboard },
  { name: 'Agents', href: '/agents', icon: Network },
  { name: 'Kanban', href: '/kanban', icon: Layers },
  { name: 'Chat', href: '/chat', icon: MessageSquare },
  { name: 'Channels', href: '/channels', icon: Radio },
  { name: 'Nodes', href: '/nodes', icon: Box },
];

export const Sidebar = () => {
  return (
    <div className="w-64 bg-gray-900 border-r border-gray-800 flex flex-col h-screen">
      {/* Logo */}
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-2xl font-bold text-white tracking-wider">
          <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
            OPENCLAW
          </span>
        </h1>
        <p className="text-gray-400 text-sm mt-1">AI Agent Gateway</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navigation.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.name}
              to={item.href}
              data-testid={`nav-${item.name.toLowerCase()}`}
              className={({ isActive }) =>
                cn(
                  'flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200',
                  isActive
                    ? 'bg-gradient-to-r from-cyan-500/20 to-blue-500/20 text-cyan-400 border border-cyan-500/30'
                    : 'text-gray-400 hover:text-white hover:bg-gray-800'
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className={cn('w-5 h-5 mr-3', isActive && 'text-cyan-400')} />
                  {item.name}
                </>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-800">
        <div className="text-xs text-gray-500 text-center">
          <p>Gateway UI v1.0</p>
          <p className="mt-1">Powered by OpenClaw</p>
        </div>
      </div>
    </div>
  );
};
